'use strict';

// WARN: This bundle pmtShared.js is also used by PinmetoAdmin and Posts. Be careful to update.
window.pmtEnv = PMTENV;
window.pmtVersionCheckHash = GITHASH;
window.inProduction = INPRODUCTION;

// Below files generate static/pmtShared.js in Grunt.
require('../../_shared/pmtShared/pmtShared.js');
require('../../_shared/pmtShared/**/*.js');
require('../../../shared/angular/**/*.js');
